import { useResetRecoilState, useSetRecoilState } from "recoil";
import { Button } from "../components/Button";
import { authState } from "../recoil";
import { useNavigate } from "react-router-dom";

export const NotFound: React.FC = () => {
  const setToken = useSetRecoilState(authState);
  const resetAuthState = useResetRecoilState(authState);
  const navigate = useNavigate();

  return (
    <div className="flex justify-center items-center flex-col gap-8 mt-20">
      <h3 className="text-5xl text-PrimaryGray">Permission Denied</h3>
      <div className="flex justify-center gap-8 items-center">
        <Button lightGreen onClick={() => navigate(-2)}>
          Back
        </Button>
        <Button
          green
          onClick={() => {
            resetAuthState();
            setToken({
              token: null,
              role: null,
              restaurantId: null,
            });
            localStorage.removeItem("token");
            navigate("/dashboard/login");
          }}
        >
          Login
        </Button>
      </div>
    </div>
  );
};
